import { playerEventsForMetricAtom } from '@/atoms/queries/player/playerEventData';
import { PLAYER_PREVIEW_EVENT_KEYS, PreviewEvents } from '@/components/tables/PreviewEvents';

export const PlayerPreviewEvents = () => (
  <PreviewEvents eventsAtom={playerEventsForMetricAtom} eventKeys={PLAYER_PREVIEW_EVENT_KEYS} />
);
